import { LoaderFunction } from '@remix-run/cloudflare';
import { useLoaderData } from '@remix-run/react';
import { LegalPage } from '~/pages/LegalPage';

export const loader: LoaderFunction = async ({ request }) => {
  const response = await fetch(new URL('./terms-of-service.md', request.url));

  const markdown = await response.text();

  return { markdown };
};

export default function ViewTermsOfService() {
  const { markdown } = useLoaderData<{ markdown: string }>();

  return <LegalPage markdown={markdown} />;
}
